import React, { useEffect, useState } from 'react';
import { Check, Star, Calculator, TrendingUp, Scissors, AlertCircle, ChevronDown, Lock, Mail, MonitorSmartphone, Heart, ShoppingBag, Sparkles, ArrowRight, Clock, Zap, Flame, Gift } from 'lucide-react';
const CHECKOUT_URL = 'https://impulsodigital.vip/cart/44779450368086:1';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/f6s8oJJ5RVvQonwJzVTbm1/ChatGPT_Image_24_may_2026,_02_01_00.png';
const CTAButton = ({
  text,
  size = 'lg',
  className = ''
}: {
  text: string;
  size?: 'md' | 'lg';
  className?: string;
}) => {
  const sizeClasses = size === 'lg' ? 'py-4 px-6 text-base md:text-lg' : 'py-3 px-5 text-sm md:text-base';
  return <a href={CHECKOUT_URL} className={`block w-full max-w-md mx-auto ${className}`} data-id="element-0">
      <button className={`w-full bg-brand-charcoal text-white font-semibold ${sizeClasses} rounded-full shadow-premium hover:bg-black transition-all duration-300 transform hover:-translate-y-0.5 flex items-center justify-center gap-2 group`} data-id="element-1">
        <span className="tracking-wide" data-id="element-2">{text}</span>
        <ArrowRight className="w-4 h-4 md:w-5 md:h-5 group-hover:translate-x-1 transition-transform" data-id="element-3" />
      </button>
    </a>;
};
export function App() {
  return <div className="min-h-screen bg-white selection:bg-brand-pink-soft selection:text-brand-charcoal overflow-x-hidden" data-id="element-4">
      <HeroSection data-id="element-5" />
      <ValueBar data-id="element-6" />
      <BonusSection data-id="element-7" />
      <ProblemSection data-id="element-8" />
      <TransformationSection data-id="element-9" />
      <ValueStackSection data-id="element-10" />
      <ReviewsSection data-id="element-11" />
      <FAQSection data-id="element-12" />
      <FinalCTASection data-id="element-13" />
    </div>;
}
function UrgencyBar() {
  return <div className="bg-brand-charcoal text-white text-center py-2.5 px-4 text-xs md:text-sm font-medium flex items-center justify-center gap-2" data-id="element-14">
      <Flame className="w-4 h-4 text-brand-pink-dark" data-id="element-15" />
      <span data-id="element-16">Oferta especial — 60% OFF + 5 BONOS GRATIS solo por hoy</span>
    </div>;
}
function HeroSection() {
  return <section className="pt-8 pb-10 px-5 md:pt-12 md:pb-16 max-w-3xl mx-auto text-center" data-id="element-17">
      <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand-nude text-brand-charcoal text-xs font-medium mb-4" data-id="element-18">
        <Sparkles className="w-3.5 h-3.5 text-brand-pink-dark" data-id="element-19" />
        <span data-id="element-20">+2.500 mujeres ya empezaron</span>
      </div>

      <h1 className="text-3xl md:text-5xl font-bold leading-[1.1] mb-4 text-balance" data-id="element-21">
        TUS PRIMEROS TOTE BAGS EN SOLO 7 DÍAS
      </h1>

      <p className="text-base md:text-lg text-gray-600 mb-6 max-w-xl mx-auto leading-snug text-balance" data-id="element-22">
        Aprendé a crear, diseñar y vender tote bags hermosas desde casa — aunque
        empieces desde cero.
      </p>

      <div className="relative mb-6 max-w-md mx-auto" data-id="element-23">
        <div className="absolute inset-0 bg-brand-pink-dark/10 rounded-3xl transform rotate-2 scale-105" data-id="element-24"></div>
        <img src={HERO_IMAGE} alt="Tus Primeros Tote Bags en 7 Días - Ebook" className="relative w-full h-auto rounded-3xl shadow-2xl object-cover z-10" data-id="element-25" />
        <div className="absolute -bottom-3 -right-3 bg-brand-pink-dark text-white text-xs font-bold px-3 py-2 rounded-full shadow-lg z-20 rotate-6" data-id="element-26">
          -60% HOY
        </div>
      </div>

      {/* Bullets compact */}
      <div className="grid grid-cols-2 gap-x-3 gap-y-2 mb-6 max-w-md mx-auto text-left text-sm" data-id="element-27">
        {['Sin experiencia previa', 'Paso a paso simple', 'Diseños listos para usar', 'Empezás desde casa', 'Acceso inmediato', '+5 bonos gratis'].map((bullet, i) => <div key={i} className="flex items-center gap-2" data-id="element-28">
            <Check className="w-3.5 h-3.5 text-brand-olive shrink-0" data-id="element-29" />
            <span className="text-gray-700 font-medium" data-id="element-30">{bullet}</span>
          </div>)}
      </div>

      {/* Price block - HIGH IMPACT */}
      <div className="bg-brand-cream border border-brand-nude-dark rounded-2xl p-5 mb-5 max-w-md mx-auto" data-id="element-31">
        <div className="flex items-center justify-center gap-2 mb-1" data-id="element-32">
          <span className="text-gray-400 line-through text-base" data-id="element-33">
            $49.990 ARS
          </span>
          <span className="bg-brand-pink-dark text-white text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-34">
            -60%
          </span>
        </div>
        <div className="flex items-baseline justify-center gap-2 mb-1" data-id="element-35">
          <span className="text-4xl md:text-5xl font-bold text-brand-charcoal" data-id="element-36">
            $19.990
          </span>
          <span className="text-sm text-gray-500 font-medium" data-id="element-37">ARS</span>
        </div>
        <p className="text-xs text-brand-olive-dark font-medium uppercase tracking-wider" data-id="element-38">
          Pago único · Acceso inmediato
        </p>
      </div>

      <CTAButton text="QUIERO EMPEZAR HOY" data-id="element-39" />

      <div className="mt-4 flex items-center justify-center gap-3 text-xs text-gray-500" data-id="element-40">
        <div className="flex gap-0.5" data-id="element-41">
          {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-3.5 h-3.5 fill-brand-pink-dark text-brand-pink-dark" data-id="element-42" />)}
        </div>
        <span className="font-medium" data-id="element-43">4.9 · +2.500 descargas</span>
      </div>
    </section>;
}
function ValueBar() {
  const items = [{
    icon: <Lock className="w-4 h-4" data-id="element-44" />,
    text: 'Pago seguro'
  }, {
    icon: <Mail className="w-4 h-4" data-id="element-45" />,
    text: 'Acceso al instante'
  }, {
    icon: <Gift className="w-4 h-4" data-id="element-46" />,
    text: '5 bonos incluidos'
  }, {
    icon: <MonitorSmartphone className="w-4 h-4" data-id="element-47" />,
    text: 'Celular y PC'
  }];
  return <div className="border-y border-gray-100 bg-white py-3 px-4" data-id="element-48">
      <div className="max-w-3xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-3 text-xs md:text-sm text-gray-600" data-id="element-49">
        {items.map((item, i) => <div key={i} className="flex items-center justify-center gap-1.5" data-id="element-50">
            <span className="text-brand-olive-dark" data-id="element-51">{item.icon}</span>
            <span className="font-medium" data-id="element-52">{item.text}</span>
          </div>)}
      </div>
    </div>;
}
function BonusSection() {
  const bonuses = [{
    title: 'Cómo vender y escalar tus tote bags',
    image: 'https://cdn.magicpatterns.com/uploads/uXHB3BLm1ai2c5S9yQADhM/ChatGPT_Image_24_may_2026,_01_43_25.png',
    value: '$20.000'
  }, {
    title: 'Calculadora de precios',
    image: 'https://cdn.magicpatterns.com/uploads/7TiqrjiT619v2A3t27TtaS/ChatGPT_Image_24_may_2026,_01_44_39.png',
    value: '$15.000'
  }, {
    title: 'Vender 100 tote bags al mes',
    image: 'https://cdn.magicpatterns.com/uploads/2HcCdKuBXXJ1XUsB6xj684/ChatGPT_Image_24_may_2026,_01_45_35.png',
    value: '$25.000'
  }, {
    title: 'Manual técnico: telas y materiales',
    image: 'https://cdn.magicpatterns.com/uploads/hAk1VQNrEfxC4AE1PXHqr5/ChatGPT_Image_24_may_2026,_01_46_58.png',
    value: '$20.000'
  }, {
    title: 'Errores que arruinan una tote bag',
    image: 'https://cdn.magicpatterns.com/uploads/ua42weugEQLJCpr8A8n2ru/ChatGPT_Image_24_may_2026,_01_48_29.png',
    value: '$15.000'
  }];
  return <section className="py-12 md:py-16 px-5 bg-brand-cream" data-id="element-53">
      <div className="max-w-4xl mx-auto" data-id="element-54">
        <div className="text-center mb-8" data-id="element-55">
          <span className="inline-flex items-center gap-1.5 bg-brand-pink-dark text-white px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-3" data-id="element-56">
            <Gift className="w-3.5 h-3.5" data-id="element-57" /> Incluidos GRATIS hoy
          </span>
          <h2 className="text-2xl md:text-4xl font-bold mb-2" data-id="element-58">
            5 Bonos exclusivos que se llevan con vos
          </h2>
          <p className="text-sm md:text-base text-gray-600" data-id="element-59">
            Valor total de los bonos:{' '}
            <span className="line-through" data-id="element-60">$95.000</span> ·{' '}
            <span className="text-brand-charcoal font-bold" data-id="element-61">HOY GRATIS</span>
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4 mb-8" data-id="element-62">
          {bonuses.map((bonus, i) => <div key={i} className="relative group" data-id="element-63">
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-white shadow-soft" data-id="element-64">
                <img src={bonus.image} alt={`Bonus ${i + 1}: ${bonus.title}`} className="w-full h-full object-cover" data-id="element-65" />
                <div className="absolute top-2 right-2 bg-brand-charcoal text-white text-[9px] font-bold px-2 py-0.5 rounded-full uppercase tracking-wide shadow-md" data-id="element-66">
                  GRATIS
                </div>
              </div>
              <div className="mt-2 text-center" data-id="element-67">
                <p className="text-[11px] text-gray-400 line-through" data-id="element-68">
                  {bonus.value}
                </p>
              </div>
            </div>)}
        </div>

        <div className="bg-white rounded-2xl p-5 border border-brand-nude-dark text-center mb-5" data-id="element-69">
          <p className="text-sm md:text-base text-gray-700 mb-1" data-id="element-70">
            <span className="font-bold" data-id="element-71">Producto + 5 bonos:</span> valor real{' '}
            <span className="line-through text-gray-400" data-id="element-72">$120.000 ARS</span>
          </p>
          <p className="text-lg md:text-xl font-bold text-brand-charcoal" data-id="element-73">
            Te lo llevás todo por{' '}
            <span className="text-brand-pink-dark" data-id="element-74">$19.990</span>
          </p>
        </div>

        <CTAButton text="QUIERO EL COMBO COMPLETO" data-id="element-75" />
      </div>
    </section>;
}
function ProblemSection() {
  const problems = [{
    icon: <Heart className="w-5 h-5" data-id="element-76" />,
    text: 'Querés emprender pero no sabés por dónde empezar'
  }, {
    icon: <ShoppingBag className="w-5 h-5" data-id="element-77" />,
    text: 'Sentís que todos venden menos vos'
  }, {
    icon: <AlertCircle className="w-5 h-5" data-id="element-78" />,
    text: 'Probaste tutoriales gratis y terminaste confundida'
  }, {
    icon: <TrendingUp className="w-5 h-5" data-id="element-79" />,
    text: 'Querés ingresos extra desde casa'
  }, {
    icon: <Sparkles className="w-5 h-5" data-id="element-80" />,
    text: 'Tenés creatividad pero no una guía clara'
  }, {
    icon: <Calculator className="w-5 h-5" data-id="element-81" />,
    text: 'Te da miedo gastar dinero y no recuperar nada'
  }];
  return <section className="py-12 md:py-16 px-5 bg-white" data-id="element-82">
      <div className="max-w-4xl mx-auto" data-id="element-83">
        <h2 className="text-2xl md:text-4xl font-bold text-center mb-2" data-id="element-84">
          ¿Te pasa esto?
        </h2>
        <p className="text-center text-gray-500 mb-8 text-sm md:text-base" data-id="element-85">
          Si te identificás con esto, esta guía es para vos
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-8" data-id="element-86">
          {problems.map((prob, i) => <div key={i} className="bg-brand-cream p-4 rounded-2xl flex items-center gap-3" data-id="element-87">
              <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center text-brand-pink-dark shrink-0" data-id="element-88">
                {prob.icon}
              </div>
              <p className="font-medium text-gray-800 text-sm md:text-base leading-snug" data-id="element-89">
                {prob.text}
              </p>
            </div>)}
        </div>

        <div className="text-center bg-brand-charcoal text-white rounded-2xl p-6 md:p-8" data-id="element-90">
          <p className="text-lg md:text-2xl font-serif italic leading-snug mb-1" data-id="element-91">
            "No es falta de talento.
          </p>
          <p className="text-lg md:text-2xl font-serif italic text-brand-pink-soft leading-snug" data-id="element-92">
            Es falta de una guía clara."
          </p>
        </div>
      </div>
    </section>;
}
function TransformationSection() {
  const benefits = [{
    text: 'Aprenderás desde cero',
    highlight: 'desde cero'
  }, {
    text: 'Vas a crear tote bags lindas y vendibles',
    highlight: 'vendibles'
  }, {
    text: 'Tendrás diseños listos para inspirarte',
    highlight: 'listos'
  }, {
    text: 'Sabrás cómo calcular precios sin perder plata',
    highlight: 'calcular precios'
  }, {
    text: 'Podrás empezar incluso desde tu casa',
    highlight: 'tu casa'
  }, {
    text: 'Crearás productos que conecten con clientes reales',
    highlight: 'clientes reales'
  }, {
    text: 'Generarás ingresos extra haciendo algo creativo',
    highlight: 'ingresos extra'
  }];
  return <section className="py-12 md:py-16 px-5 bg-brand-nude/40" data-id="element-93">
      <div className="max-w-3xl mx-auto" data-id="element-94">
        <div className="text-center mb-8" data-id="element-95">
          <span className="text-brand-olive-dark font-bold text-xs uppercase tracking-widest mb-2 block" data-id="element-96">
            La transformación
          </span>
          <h2 className="text-2xl md:text-4xl font-bold leading-tight" data-id="element-97">
            Esto vas a lograr en 7 días
          </h2>
        </div>

        <div className="bg-white rounded-3xl p-6 md:p-8 shadow-soft mb-6" data-id="element-98">
          <div className="space-y-3" data-id="element-99">
            {benefits.map((benefit, i) => <div key={i} className="flex items-start gap-3 pb-3 border-b border-gray-100 last:border-0 last:pb-0" data-id="element-100">
                <div className="mt-0.5 bg-brand-pink-soft p-1 rounded-full shrink-0" data-id="element-101">
                  <Check className="w-4 h-4 text-brand-charcoal" strokeWidth={3} data-id="element-102" />
                </div>
                <p className="text-base md:text-lg text-gray-800 leading-snug" data-id="element-103">
                  {benefit.text}
                </p>
              </div>)}
          </div>
        </div>

        <CTAButton text="QUIERO LOGRAR ESTO" data-id="element-104" />
      </div>
    </section>;
}
function ValueStackSection() {
  const items = [{
    name: 'Ebook principal: Tus primeros tote bags en 7 días',
    value: 25000
  }, {
    name: 'BONUS 1: Cómo vender y escalar desde casa',
    value: 20000
  }, {
    name: 'BONUS 2: Calculadora de precios',
    value: 15000
  }, {
    name: 'BONUS 3: Cómo vender 100 tote bags al mes',
    value: 25000
  }, {
    name: 'BONUS 4: Manual técnico de telas',
    value: 20000
  }, {
    name: 'BONUS 5: Errores que arruinan una tote bag',
    value: 15000
  }];
  const total = items.reduce((sum, i) => sum + i.value, 0);
  return <section className="py-12 md:py-16 px-5 bg-white" data-id="element-105">
      <div className="max-w-2xl mx-auto" data-id="element-106">
        <div className="text-center mb-8" data-id="element-107">
          <span className="inline-block bg-brand-pink-soft text-brand-charcoal px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-3" data-id="element-108">
            La oferta completa
          </span>
          <h2 className="text-2xl md:text-4xl font-bold leading-tight text-balance" data-id="element-109">
            Más de <span className="text-brand-pink-dark" data-id="element-110">$120.000</span> en
            valor por solo $19.990
          </h2>
        </div>

        <div className="bg-brand-cream rounded-3xl p-5 md:p-7 mb-5" data-id="element-111">
          <div className="space-y-2.5 mb-5 pb-5 border-b border-brand-nude-dark" data-id="element-112">
            {items.map((item, i) => <div key={i} className="flex justify-between items-center gap-3 text-sm md:text-base" data-id="element-113">
                <span className="font-medium text-gray-700 flex items-start gap-2 leading-snug" data-id="element-114">
                  <Check className="w-4 h-4 text-brand-olive mt-1 shrink-0" data-id="element-115" />
                  {item.name}
                </span>
                <span className="text-gray-400 font-medium whitespace-nowrap" data-id="element-116">
                  ${item.value.toLocaleString('es-AR')}
                </span>
              </div>)}
          </div>

          <div className="flex justify-between items-center mb-2 text-sm" data-id="element-117">
            <span className="text-gray-500" data-id="element-118">Valor total real:</span>
            <span className="text-gray-400 line-through font-semibold" data-id="element-119">
              ${total.toLocaleString('es-AR')} ARS
            </span>
          </div>
          <div className="flex justify-between items-center mb-3 text-sm" data-id="element-120">
            <span className="text-gray-500" data-id="element-121">Precio normal:</span>
            <span className="text-gray-400 line-through font-semibold" data-id="element-122">
              $49.990 ARS
            </span>
          </div>

          <div className="bg-white rounded-2xl p-4 text-center border-2 border-brand-pink-dark" data-id="element-123">
            <span className="text-xs font-bold text-brand-pink-dark uppercase tracking-widest block mb-1" data-id="element-124">
              Precio hoy
            </span>
            <div className="flex items-baseline justify-center gap-2" data-id="element-125">
              <span className="text-4xl md:text-5xl font-bold text-brand-charcoal" data-id="element-126">
                $19.990
              </span>
              <span className="text-sm text-gray-500 font-medium" data-id="element-127">ARS</span>
            </div>
            <p className="text-xs text-brand-olive-dark font-medium mt-1" data-id="element-128">
              Pago único · Acceso inmediato + actualizaciones
            </p>
          </div>
        </div>

        <CTAButton text="QUIERO TODO EL COMBO" data-id="element-129" />
        <p className="text-center text-xs text-gray-500 mt-3 flex items-center justify-center gap-1.5" data-id="element-130">
          <Clock className="w-3.5 h-3.5" data-id="element-131" /> Esta oferta puede cerrarse en
          cualquier momento
        </p>
      </div>
    </section>;
}
function ReviewsSection() {
  const reviews = [{
    name: 'Valentina M.',
    age: '26 años',
    text: 'Recuperé la inversión con mis primeras 3 ventas. No lo podía creer.',
    tag: 'Primer mes'
  }, {
    name: 'Sofía R.',
    age: '34 años',
    text: 'Por fin entendí cómo cobrar sin regalar mi trabajo. La calculadora vale el combo entero.',
    tag: 'Verificada'
  }, {
    name: 'Camila G.',
    age: '29 años',
    text: 'Hice mis primeras 12 totes en una semana. Ya las vendí todas a amigas y conocidas.',
    tag: '12 ventas'
  }, {
    name: 'Martina L.',
    age: '41 años',
    text: 'Empecé sin saber coser. Hoy tengo Instagram con pedidos esperando. Es real.',
    tag: 'Resultados'
  }, {
    name: 'Lucía P.',
    age: '23 años',
    text: 'No es un PDF cualquiera. Es como tener una mentora paso a paso. Súper claro todo.',
    tag: 'Verificada'
  }, {
    name: 'Agustina D.',
    age: '37 años',
    text: 'Vendí 47 totes en mi primer mes desde mi casa. Mi marido no podía creerlo.',
    tag: '47 ventas'
  }, {
    name: 'Florencia B.',
    age: '31 años',
    text: 'Los bonos solos ya valen mil veces lo que pagué. Imprescindible.',
    tag: 'Primer mes'
  }, {
    name: 'Antonella S.',
    age: '28 años',
    text: 'Llevo 3 meses y ya es mi ingreso principal. Renuncié a mi trabajo de medio turno.',
    tag: 'Resultados'
  }];
  return <section className="py-12 md:py-16 px-5 bg-brand-nude/30" data-id="element-132">
      <div className="max-w-5xl mx-auto" data-id="element-133">
        <div className="text-center mb-8" data-id="element-134">
          <div className="flex items-center justify-center gap-1 mb-3" data-id="element-135">
            {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-brand-pink-dark text-brand-pink-dark" data-id="element-136" />)}
            <span className="text-sm font-bold ml-2" data-id="element-137">
              4.9 / 5 · 2.500+ compradoras
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold" data-id="element-138">
            Resultados reales de otras emprendedoras
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4 mb-8" data-id="element-139">
          {reviews.map((review, i) => <div key={i} className="bg-white p-4 md:p-5 rounded-2xl shadow-soft flex flex-col" data-id="element-140">
              <div className="flex items-center justify-between mb-2" data-id="element-141">
                <div className="flex gap-0.5" data-id="element-142">
                  {[1, 2, 3, 4, 5].map(s => <Star key={s} className="w-3.5 h-3.5 fill-brand-pink-dark text-brand-pink-dark" data-id="element-143" />)}
                </div>
                <span className="text-[10px] font-bold text-brand-olive-dark bg-brand-cream px-2 py-0.5 rounded-full uppercase tracking-wider" data-id="element-144">
                  {review.tag}
                </span>
              </div>
              <p className="text-gray-700 text-sm leading-snug mb-3 flex-1" data-id="element-145">
                "{review.text}"
              </p>
              <div className="flex items-center gap-2 pt-2 border-t border-gray-100" data-id="element-146">
                <div className="w-7 h-7 bg-brand-pink-soft rounded-full flex items-center justify-center text-xs font-bold text-brand-charcoal" data-id="element-147">
                  {review.name[0]}
                </div>
                <div data-id="element-148">
                  <p className="font-bold text-xs text-brand-charcoal leading-tight" data-id="element-149">
                    {review.name}
                  </p>
                  <p className="text-[10px] text-gray-500" data-id="element-150">{review.age}</p>
                </div>
              </div>
            </div>)}
        </div>

        <CTAButton text="QUIERO ESTOS RESULTADOS" data-id="element-151" />
      </div>
    </section>;
}
function FAQSection() {
  const faqs = [{
    q: '¿Necesito experiencia?',
    a: 'No, está diseñada para que empieces desde cero absoluto. Cada paso está explicado de forma sencilla.'
  }, {
    q: '¿Qué incluye el paso a paso?',
    a: 'Materiales, diseño, confección, cálculo de precios y estrategias para vender tus primeras unidades.'
  }, {
    q: '¿Cómo recibo el producto?',
    a: 'Es 100% digital. Apenas confirmás el pago recibís el acceso en tu email al instante.'
  }, {
    q: '¿Puedo empezar desde casa?',
    a: 'Totalmente. No necesitás taller, solo un pequeño espacio en tu casa.'
  }, {
    q: '¿Necesito máquina profesional?',
    a: 'No, podés empezar con una máquina familiar básica o tercerizar la confección (te enseñamos cómo).'
  }, {
    q: '¿Tiene garantía?',
    a: 'Sí, 7 días de garantía. Si no es para vos, te devolvemos el 100% sin preguntas.'
  }, {
    q: '¿Cuándo recibo acceso?',
    a: 'Inmediato. Apenas se confirma el pago, todo llega automáticamente a tu email.'
  }, {
    q: '¿Es digital?',
    a: 'Sí, combo digital (Ebooks + Guías en PDF). Empezás hoy mismo sin esperar envíos.'
  }];
  return <section className="py-12 md:py-16 px-5 bg-white" data-id="element-152">
      <div className="max-w-2xl mx-auto" data-id="element-153">
        <h2 className="text-2xl md:text-4xl font-bold text-center mb-8" data-id="element-154">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-2" data-id="element-155">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-156" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="bg-brand-cream rounded-2xl overflow-hidden" data-id="element-157">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-158">
        <span className="font-semibold text-sm md:text-base text-brand-charcoal pr-4" data-id="element-159">
          {question}
        </span>
        <ChevronDown className={`w-4 h-4 text-brand-olive transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-160" />
      </button>
      <div className={`px-5 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-48 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-161">
        <p className="text-gray-600 text-sm leading-relaxed" data-id="element-162">{answer}</p>
      </div>
    </div>;
}
function FinalCTASection() {
  return <section className="py-16 md:py-20 px-5 bg-brand-charcoal text-white text-center" data-id="element-163">
      <div className="max-w-2xl mx-auto" data-id="element-164">
        <div className="inline-flex items-center gap-1.5 bg-brand-pink-dark/20 text-brand-pink-soft px-3 py-1 rounded-full text-xs font-bold uppercase tracking-widest mb-4" data-id="element-165">
          <Flame className="w-3.5 h-3.5" data-id="element-166" /> Última oportunidad
        </div>

        <h2 className="text-3xl md:text-5xl font-serif mb-4 text-balance leading-tight" data-id="element-167">
          Tu emprendimiento puede empezar hoy.
        </h2>

        <p className="text-base md:text-lg text-gray-300 mb-8 max-w-lg mx-auto" data-id="element-168">
          No necesitás hacerlo perfecto. Solo empezar. Miles de mujeres ya
          tomaron la decisión.
        </p>

        <div className="bg-white/5 border border-white/10 rounded-2xl p-5 mb-6 max-w-md mx-auto" data-id="element-169">
          <div className="flex items-center justify-center gap-2 mb-2 text-sm" data-id="element-170">
            <span className="text-gray-400 line-through" data-id="element-171">
              $120.000 valor real
            </span>
            <span className="bg-brand-pink-dark text-white text-[10px] font-bold px-2 py-0.5 rounded-full" data-id="element-172">
              -83%
            </span>
          </div>
          <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-173">
            <span className="text-5xl font-bold" data-id="element-174">$19.990</span>
            <span className="text-sm text-gray-400" data-id="element-175">ARS</span>
          </div>
          <p className="text-xs text-brand-pink-soft uppercase tracking-widest font-bold" data-id="element-176">
            Producto + 5 bonos GRATIS
          </p>
        </div>

        <a href={CHECKOUT_URL} className="block w-full max-w-md mx-auto mb-6" data-id="element-177">
          <button className="w-full bg-brand-pink-dark text-white font-bold text-base md:text-lg py-4 px-6 rounded-full shadow-premium hover:bg-brand-pink-dark/90 transition-all duration-300 transform hover:-translate-y-0.5 flex items-center justify-center gap-2" data-id="element-178">
            QUIERO MI COMBO COMPLETO
            <ArrowRight className="w-5 h-5" data-id="element-179" />
          </button>
        </a>

        <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs text-gray-400 font-medium" data-id="element-180">
          <div className="flex items-center gap-1.5" data-id="element-181">
            <Lock className="w-3.5 h-3.5" data-id="element-182" /> Pago seguro
          </div>
          <div className="flex items-center gap-1.5" data-id="element-183">
            <Mail className="w-3.5 h-3.5" data-id="element-184" /> Acceso inmediato
          </div>
          <div className="flex items-center gap-1.5" data-id="element-185">
            <MonitorSmartphone className="w-3.5 h-3.5" data-id="element-186" /> Celular y PC
          </div>
          <div className="flex items-center gap-1.5" data-id="element-187">
            <Zap className="w-3.5 h-3.5" data-id="element-188" /> Garantía 7 días
          </div>
        </div>
      </div>
    </section>;
}